/** @format */

export const EnvelopeLarge = ({color}) => {
    return (
        <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M27.375 6C28.8242 6 30 7.11927 30 8.5C30 9.28646 29.6117 10.026 28.95 10.5L17.05 19C16.4266 19.4427 15.5734 19.4427 14.95 19L3.05 10.5C2.38899 10.026 2 9.28646 2 8.5C2 7.11927 3.17523 6 4.625 6H27.375ZM13.9 20.3333C15.1469 21.224 16.8531 21.224 18.1 20.3333L30 11.8333V22.6667C30 24.5052 28.4305 26 26.5 26H5.5C3.5668 26 2 24.5052 2 22.6667V11.8333L13.9 20.3333Z"
                fill={color}
            />
        </svg>
    );
};
